<template>

	<section id="Landing">

		<video id="Screensaver" autoplay muted :loop="screenSaverLoop" @ended="showIntro = true">

			<source src="/image/screensaver.mp4" />

		</video>

		<video id="Intro" autoplay muted v-if="showIntro" @ended="$router.push('/home')">

			<source :src="getIntro()" />

		</video>

		<div id="Blocker"></div>

	</section>

</template>

<script>

	import i18n from '@/plugins/i18n';

	export default {
		data () {
			return {
				screenSaverLoop: true,
				showIntro: false
			};
		},
		methods: {
			getIntro () {
				return '/image/intro.' + i18n.locale + '.mp4';
			}
		},
		created () {
			window.addEventListener('mousedown', (evt) => {
				if (this.$route.name === 'landing') {
					this.screenSaverLoop = false;
				}
			});
		}
	};

</script>